import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=2f92d158&scoped=true"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f92d158",
  null
  
)

export default component.exports